<template>
  <PlaceholderPantalla
    titulo="Punto de Venta"
    subtitulo="Registro rápido de órdenes de impresión"
    descripcion="Interfaz optimizada para registrar órdenes de trabajos de impresión. Selecciona productos del catálogo (tarjetas, volantes, lonas, etc.), configura especificaciones (cantidad, tamaño, acabados), calcula precios automáticamente, aplica descuentos, registra anticipos, procesa pagos y genera tickets de trabajo. Integrado con inventario y finanzas."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../../Finanzas/PlaceholderPantalla.vue'

const funcionalidades = [
  'Interfaz optimizada para captura rápida de órdenes',
  'Catálogo visual de productos de impresión',
  'Búsqueda rápida de productos por nombre o código',
  'Configurar especificaciones: cantidad, tamaño, papel, acabados',
  'Cálculo automático de precio según especificaciones',
  'Asignar orden a cliente (nuevo o existente)',
  'Calcular total con IVA y descuentos',
  'Aplicar descuentos (%, monto fijo, promociones)',
  'Registrar anticipo/enganche',
  'Calcular saldo pendiente',
  'Procesar pago: Efectivo, Tarjeta, Transferencia, Mixto',
  'Calcular cambio automáticamente',
  'Generar e imprimir ticket de trabajo',
  'Crear cuenta por cobrar si hay saldo pendiente',
  'Generar ingreso automático en módulo Finanzas',
  'Cancelación de órdenes con autorización',
  'Reimpresión de tickets',
  'Historial de órdenes del día'
]

const datosManejados = [
  'Número de orden/folio',
  'Fecha y hora de la orden',
  'Cliente (nombre, teléfono, email)',
  'Lista de productos/trabajos solicitados',
  'Especificaciones por producto (cantidad, tamaño, papel, tintas, acabados)',
  'Precio unitario y total por producto',
  'Subtotal de la orden',
  'Descuentos aplicados',
  'IVA',
  'Total a pagar',
  'Anticipo/enganche',
  'Saldo pendiente',
  'Método de pago del anticipo',
  'Fecha de entrega prometida',
  'Estado (Pendiente, En Proceso, Terminada, Entregada)',
  'Notas especiales para producción',
  'Usuario que registró la orden',
  'Tickets impresos'
]
</script>
